export const MOS_HELP_LINK = 'https://school.mos.ru/help';
export const TALENT_MAP_LINK = 'https://talent.mosreg.ru';
